import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Field, getFormSyncErrors, getFormValues, reduxForm } from "redux-form";
import { renderTextField } from "components/FormFields/FieldTypes";
import { Required, emailValidator } from "components/FormFields/validators";
import { connect } from "react-redux";
import { homeActions } from "actions";

const SendHCPEmailMessagePopUp = (props) => {
  const {
    showSendEmailMessage,
    onCancel,
    formErrors,
    formValues,
    shareHCPCoupon,
    sendHcpTextMessageInfo,
    resetHCPSendTextInfo,
    showTextCoupon = false,
    updateGTMDataLayer,
    organizationInfo,
    shareCoupon = false,
    shareApp = false,
    selectedInsurance,
    couponData,
    sendHcpTextMessageIisProgress,
    reset,
    viewCouponLinkClick = null,
    viewCouponLink = false,
    disableCancelBtn = false,
  } = props;
  console.log(shareApp);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const theme = useTheme();

  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  const onSubmitPopUpData = () => {
    console.log(couponData);
    const storedInsuranceData = JSON.parse(
      localStorage.getItem("storedInsuranceData")
    );
    let data = {
      productDetailId: null,
      quantity: 0.0,
      insuranceId: null,
      phoneNumber: null,
      email: null,
    };
    if (shareCoupon) {
      data = {
        productDetailId: couponData?.productDetailId,
        quantity: 0.0,
        insuranceId: selectedInsurance?.id || storedInsuranceData?.id,
        phoneNumber: null,
        email: null,
        pharmacyGroupId: couponData?.pharmacyGroupId || null,
      };
    }
    shareHCPCoupon({
      ...data,
      ...formValues,
      email: formValues?.recipientEmail,
      phoneNumber: null,
    });
    updateGTMDataLayer({
      event: couponData
        ? "Get_hcp_savings_share_email"
        : "Get_hcp_site_share_email",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      ...formValues,
    });
  };

  const onSuccessDone = () => {
    setShowSuccess(false);
    onCancel();
    reset();
  };

  const onFailedDone = () => {
    setShowFailure(false);
    onCancel();
    reset();
  };

  useEffect(() => {
    updateGTMDataLayer({
      event: couponData
        ? "Get_hcp_savings_share_email_attempt"
        : "Get_hcp_site_share_email_attempt",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
    });
    return () => {
      setShowSuccess(false);
      setShowFailure(false);
      resetHCPSendTextInfo();
      reset();
    };
  }, []);

  useEffect(() => {
    setShowFailure(false);
    setShowSuccess(false);
    if (
      sendHcpTextMessageInfo &&
      sendHcpTextMessageInfo.data &&
      sendHcpTextMessageInfo.success
    ) {
      setShowSuccess(true);
    }
    if (
      Object.keys(sendHcpTextMessageInfo).length &&
      !sendHcpTextMessageInfo.data &&
      !sendHcpTextMessageInfo.success
    ) {
      setShowFailure(true);
    }
  }, [sendHcpTextMessageInfo]);

  const renderLayout = () => {
    return (
      <DialogContent
        sx={{ padding: showTextCoupon ? "15px 24px 0px 24px" : "40px" }}
      >
        {sendHcpTextMessageIisProgress ? (
          <div
            style={{
              height: "300px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <CircularProgress
              style={{ color: theme?.palette?.secondary?.main }}
            />
          </div>
        ) : !showSuccess && !showFailure ? (
          <form>
            <Box
              component="div"
              sx={{
                textAlign: "center",
                width: matchesMinWidth ? undefined : "500px",
                minHeight: "600px",
                borderRadius: "20px",
              }}
            >
              <Box mb={3} sx={{ fontWeight: 500 }}>
                <Typography
                  variant="h2LatoMedium"
                  sx={{
                    fontWeight: 500,
                    fontSize: 16,
                    textAlign: "center",
                    color: "#607277",
                  }}
                >
                  Enter the information to email this coupon:
                </Typography>
              </Box>
              <Box mb={4}>
                <Box mb={2}>
                  <Field
                    name="recipientEmail"
                    isRequired
                    component={renderTextField}
                    label="Recipient’s email address"
                    validate={[Required, emailValidator]}
                  />
                </Box>
                <Box mb={2}>
                  <Field
                    name="recipientName"
                    component={renderTextField}
                    label="Recipient's name (optional)"
                  />
                </Box>
                <Box>
                  <Field
                    name="senderName"
                    component={renderTextField}
                    label="Sender's name (optional)"
                  />
                </Box>
              </Box>
              <Box mb={3} sx={{ textAlign: "center" }}>
                <Typography variant="h4LatoBold" sx={{ fontSize: "12px" }}>
                  By continuing to use this website, you agree to the <br />
                  Cuverd{" "}
                  <Box
                    component={Link}
                    to="/terms-and-conditions"
                    sx={
                      {
                        //textDecoration: "none",
                      }
                    }
                  >
                    <Typography
                      component={"span"}
                      sx={{ fontSize: "12px" }}
                      variant="h3LatoBoldNew"
                    >
                      Terms and Conditions
                    </Typography>
                  </Box>{" "}
                  and{" "}
                  <Box
                    component={Link}
                    to="/privacy-policy"
                    sx={
                      {
                        //textDecoration: "none",
                      }
                    }
                  >
                    <Typography
                      component={"span"}
                      sx={{ fontSize: "12px" }}
                      variant="h3LatoBoldNew"
                    >
                      Privacy Policy
                    </Typography>
                  </Box>{" "}
                </Typography>
              </Box>
              <Box mb={4}>
                <Button
                  variant="large"
                  type="button"
                  onClick={() => onSubmitPopUpData()}
                  disabled={Object.keys(formErrors).length ? true : false}
                  sx={{
                    backgroundColor: Object.keys(formErrors).length
                      ? "#e6e6e6"
                      : `${organizationInfo?.colorSchemeJson?.primaryButtonColor}`,
                    width: matchesMinWidth ? undefined : "100%",
                    fontSize: matchesMinWidth ? "14px" : undefined,
                    minWidth: matchesMinWidth ? "200px" : undefined,
                    color: Object.keys(formErrors).length
                      ? "#637276"
                      : `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: `${organizationInfo?.colorSchemeJson?.primaryButtonColor}`,
                    },
                  }}
                >
                  SEND
                </Button>
              </Box>
              {viewCouponLink && viewCouponLinkClick && (
                <Box mx="auto" sx={{ width: "100%" }}>
                  <Button
                    variant="text"
                    sx={{
                      width: matchesMinWidth ? undefined : "100%",
                      fontSize: matchesMinWidth ? "14px" : undefined,
                      minWidth: matchesMinWidth ? "200px" : undefined,
                      textDecoration: "underline",
                      //color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                    }}
                    onClick={() => {
                      onCancel();
                      viewCouponLinkClick();
                    }}
                  >
                    View Savings
                  </Button>
                </Box>
              )}

              {!disableCancelBtn && (
                <Box
                  mx="auto"
                  sx={{ width: matchesMinWidth ? undefined : "100%" }}
                >
                  <Button
                    variant="text"
                    sx={{
                      width: matchesMinWidth ? undefined : "100%",
                      fontSize: matchesMinWidth ? "14px" : undefined,
                      minWidth: matchesMinWidth ? "200px" : undefined,
                      textDecoration: "underline",
                      //color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                    }}
                    onClick={onCancel}
                  >
                    {/* <Typography
                variant="text2"
                sx={{
                  fontFamily: "Lato-Regular",
                  fontWeight: 600,
                  fontSize: 18,
                  textDecoration: "underline",
                }}
              > */}
                    CANCEL
                    {/* </Typography> */}
                  </Button>
                </Box>
              )}
            </Box>
          </form>
        ) : (
          <Box sx={{ textAlign: "center" }}>
            {showSuccess ? (
              <Box>
                <Box mb={4}>
                  <Typography variant="h2LatoBold">
                    {shareApp ? "Website" : "Coupon"} sent!
                  </Typography>
                </Box>
                <Box mb={7}>
                  <Typography variant="h2LatoMedium">
                    You have successfully sent a{" "}
                    {shareApp ? "website" : "coupon"} to{" "}
                    {formValues?.recipientEmail}.
                  </Typography>
                </Box>
                <Box mb={3}>
                  <Button
                    variant="large"
                    sx={{
                      minWidth: { xs: "150px", sm: "100%", md: undefined },
                    }}
                    onClick={() => onSuccessDone()}
                  >
                    OK
                  </Button>
                </Box>
              </Box>
            ) : null}
            {showFailure ? (
              <Box>
                <Box mb={2}>
                  <Typography variant="h2LatoBold">Send Email Error</Typography>
                </Box>
                <Box mb={3}>
                  <Typography variant="h2LatoMedium">
                    {sendHcpTextMessageInfo?.message}
                  </Typography>
                </Box>
                <Box mb={2}>
                  <Button variant="large" onClick={() => onFailedDone()}>
                    OK
                  </Button>
                </Box>
              </Box>
            ) : null}
          </Box>
        )}
      </DialogContent>
    );
  };

  return (
    <>
      {showTextCoupon ? (
        renderLayout()
      ) : (
        <Box>
          <Dialog
            open={showSendEmailMessage}
            className="app-dialog"
            onClose={onCancel}
          >
            {renderLayout()}
          </Dialog>
        </Box>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("SEND_EMAIL_FORM")(state) || {},
    formValues: getFormValues("SEND_EMAIL_FORM")(state),
    sendHcpTextMessageInfo: state.sendHcpTextMessageInfo.data,
    organizationInfo: state.organizationInfo.data || {},
    selectedInsurance: state.insuranceList.selectedInsurance,
    sendHcpTextMessageIisProgress: state.sendHcpTextMessageInfo.isProgress,
  };
};

const mapDispatchToProps = {
  shareHCPCoupon: (params) => homeActions.shareHCPCoupon(params),
  resetHCPSendTextInfo: () => homeActions.resetHCPSendTextInfo(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "SEND_EMAIL_FORM",
  })(SendHCPEmailMessagePopUp)
);
